<template>
    <v-card elevation="2" outlined>
        <v-card-title>
            مشخصات کاربر
            <v-spacer/>
            <v-icon>mdi-account</v-icon>
        </v-card-title>

        <v-divider/>

        <v-list>
            <v-list-item>
                <v-list-item-avatar>
                    <v-img :src=" details.image || '/image/avatar.png'"/>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-text="details.name"/>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="details.phone"/>
                    <v-list-item-subtitle>شماره همراه</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-shield-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="details.username"/>
                    <v-list-item-subtitle>نام کاربری</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-account-alert-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="details.type == 'regular'? 'شخص حقوقی': 'شخص حقیقی'"/>
                    <v-list-item-subtitle>نوع حساب</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="details.email"/>
                    <v-list-item-subtitle>ایمیل</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-shield-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="$options.filters.longDate(details.created_at)"/>
                    <v-list-item-subtitle>تاریخ ثبت نام</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

        </v-list>
    </v-card>
</template>

<script>
export default {
    name: "userDetails",

    props: ['details']
}
</script>

<style scoped>

</style>
